import { render, staticRenderFns } from "./DatasetGroupSelector.vue?vue&type=template&id=22cb76d9&scoped=true"
import script from "./DatasetGroupSelector.vue?vue&type=script&lang=js"
export * from "./DatasetGroupSelector.vue?vue&type=script&lang=js"
import style0 from "./DatasetGroupSelector.vue?vue&type=style&index=0&id=22cb76d9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22cb76d9",
  null
  
)

export default component.exports